import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DipRegistrationContextService } from '../dip-registration-context.service';
import { getApiUrl } from '../utilities/dip-registration-utility';
import { DiprsLoggerService } from './diprs-logger.service';
import { UtilityService } from '../../utilities/utility.service';
import { DynamicEventLogContent, LoggerDeviceType } from '../../models/dip-registration-log-information.model';

@Injectable()
export class DiprsSpaLoggerService extends DiprsLoggerService {
  constructor(http: HttpClient,
              private utilityService: UtilityService,
              private dipRegistrationContextService: DipRegistrationContextService
             ) {
    super(http);
  }

  protected getCustomInfo(): DynamicEventLogContent {
    const customInfo: DynamicEventLogContent = {
      eventType: 'DIPRS_FRONT_END',
      userDeviceType: this.utilityService.isMobile() ? LoggerDeviceType.MOBILE : LoggerDeviceType.WEB,
      userLanguage: this.dipRegistrationContextService.getLanguage(),
      logEndpointURL: `${getApiUrl()}/v1/frontend-event-log`
    };

    return customInfo;
  }

}

